// extracted by mini-css-extract-plugin
export default {"QRCode":"QRCode_QRCode__PPrp8","attribution":"QRCode_attribution__Y4w4r"};